module.exports = "/images/trdt.png?a5259192a147e748cf01b0319678b41e";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/img/trdt.png
// module id = cTz9
// module chunks = 0